import { Component, inject } from '@angular/core';
import { FormControl } from '@angular/forms';
import { PojavniOblik } from '@app/shared/models/pojavni-oblik';
import { DynamicFormService } from '@ntap/common';
import { ItemViewProviderDirective, UIComponents } from '@ntap/core';
import { PrimeNGInputTextComponent } from '@ntap/primeng';
import { map, tap } from 'rxjs';

@Component({
  selector: 'app-naziv-pojavnog-oblika',
  templateUrl: './naziv-pojavnog-oblika.component.html',
  styleUrls: ['./naziv-pojavnog-oblika.component.scss']
})
export class NazivPojavnogOblikaComponent extends PrimeNGInputTextComponent {
  oznakaFormControlName = 'en~pojavni_oblik~oznaka_naziva';
  nazivComponentId: string;
  override formService = inject(DynamicFormService);
  itemViewProvider = inject(ItemViewProviderDirective);
  oznakaFormControl: FormControl;
  prefiksNazivaCompId = UIComponents.INPUT_TEXT;
  placeholder = 'Oznaka pojavnog oblika';

  oznakaDisabled$ = this.itemViewProvider.item$.pipe(
    map((item: PojavniOblik | any) => item['en~pojavni_oblik~status'] !== 'T'),
    tap((disabled) => {
      this.placeholder = disabled
        ? ''
        : 'Oznaka pojavnog oblika (unos opcionalan)';
    })
  );

  override doChangedInputParam() {
    super.doChangedInputParam();
    this.oznakaFormControl = this.formService.registerFormControl(
      this.oznakaFormControlName
    );
    this.addSubscription(
      this.itemViewProvider.item$
        .pipe(
          tap((item: any) => {
            this.oznakaFormControl.setValue(item[this.oznakaFormControlName]);
          })
        )
        .subscribe()
    );
  }
}
